import { memo } from 'react';

import SearchIconSVG from '@/assets/search-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISearchIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={SearchIconSVG} {...props} />;

export const SearchIcon = memo(ISearchIcon) as typeof ISearchIcon;
